import { SET_USERS, SET_ERROR } from '../actionTypes'
import Swal from 'sweetalert2'
const url = `https://server-movie-synopsis.herokuapp.com`
// const url = `http://localhost:3000`

export function getUser(data) {
  return (dispatch) => {
    fetch(`https://server-movie-synopsis.herokuapp.com/login`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: data.email,
        password: data.password
      })
    })
    .then((res) => res.json())
    .then((user) => {
      localStorage.setItem('token', user.access_token)
      // dispatch({
      //   type: SET_USERS,
      //   payload: user
      // })
    }).catch((err) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: `${err}`,
      })
      dispatch({
        type: SET_ERROR,
        payload: err
      })
    });
  }
}

export function createUser(user) {
  return (dispatch) => {
    fetch(`https://server-movie-synopsis.herokuapp.com/register`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: user.email,
        password: user.password,
        role: user.role,
        phoneNumber: user.phoneNumber,
        address: user.address
      })
    })
    .then(() => {
      Swal.fire('Saved!', 'User Created', 'success')
    }).catch((err) => {
      console.log(err)
    });
  }
}

